module.exports = __webpack_public_path__ + "img/car-grey.456d3925.svg";